import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './sidebar';
import Heading from '../common/heading/Heading';
import { modules } from './common/accessConfig';

const MainLayout = () => {
  const location = useLocation();

  // Find the title based on the current route
  const getTitle = () => {
    // Flatten modules and subModules to search for the matching path
    const allModules = modules.flatMap((module) =>
      module.subModules
        ? [
            { name: module.name, path: module.path },
            ...module.subModules.map((sub) => ({
              name: sub.name,
              path: sub.path,
            })),
          ]
        : [{ name: module.name, path: module.path }]
    );

    const currentModule = allModules.find(
      (module) => module.path === location.pathname
    );
    return currentModule ? currentModule.name : 'Admin Panel';
  };

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex flex-col w-100">
        <Heading title={getTitle()} />
        <div className="">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;